export const priceList = {
  topGainers: [
    {
      id: 1,
      company: 'STANBIC',
      prev: '0.65',
      current: '0.71',
      change: '9.23',
    },
    {
      id: 2,
      company: 'ACCESS',
      prev: '0.45',
      current: '0.65',
      change: '0.15%',
    },
    {
      id: 3,
      company: 'PEAS',
      prev: '0.15',
      current: '0.55',
      change: '0.45%',
    },
    {
      id: 4,
      company: 'ABCTRNX',
      prev: '1.65',
      current: '2.65',
      change: '1.65%',
    },
    {
      id: 5,
      company: 'JBERGER',
      prev: '3.65',
      current: '0.45',
      change: '3.25%',
    },
  ],

  topLosers: [
    {
      id: 1,
      company: 'STANBIC',
      prev: '0.65',
      current: '0.71',
      change: '9.23',
    },
    {
      id: 2,
      company: 'ACCESS',
      prev: '0.45',
      current: '0.65',
      change: '0.15%',
    },
    {
      id: 3,
      company: 'PEAS',
      prev: '0.15',
      current: '0.55',
      change: '0.45%',
    },
    {
      id: 4,
      company: 'ABCTRNX',
      prev: '1.65',
      current: '2.65',
      change: '1.65%',
    },
    {
      id: 5,
      company: 'JBERGER',
      prev: '3.65',
      current: '0.45',
      change: '3.25%',
    },
  ],
};
